import { Environment } from '@fxp/fxpservices';
import { dev } from '../configs/appSettings.dev';
import { prod } from '../configs/appSettings.prod';
import { sit } from '../configs/appSettings.sit';
import { uat } from '../configs/appSettings.uat';
import { IPartnerAppSettings } from '../interface/IPartnerAppSettings';

export const appSettings = (): IPartnerAppSettings => {
  let appSetting;
  console.info("Checking ",window && window['FxpAppSettings'] && window['FxpAppSettings'].EnvironmentName);
  switch (window && window['FxpAppSettings'] && window['FxpAppSettings'].EnvironmentName) {
    case Environment && Environment.Dev:
      appSetting = dev;
      break;
    case Environment && Environment.Sit:
      appSetting = sit;
      break;
    case Environment && Environment.Uat:
      appSetting = uat;
      break;
    case Environment && Environment.Prod:
      appSetting = prod;
      break;
    default:
      appSetting = dev;
      break;
  }

  return appSetting;
};
